const lazyPageComponent = () => import('@/Pages/Ru/ExclusiveRights.vue');

export const exclusiveRightsRoutes = [
  {
    path: '/exclusive-rights',
    pathname: '/exclusive-rights',
    name: 'exclusive-rights',
    component: lazyPageComponent,
    meta: {
      name: 'exclusive-rights',
    },
  },
];
